import Web3 from "web3";
import toast from "react-hot-toast";
import config from "../../config/config";
import { updateCreditWalletStatusAction } from "../../Action/user.action";
import { Virtual } from "swiper/modules";

export const getChainId = async (web3) => {
  try {
    return await web3.eth.getChainId();
  } catch (error) {
    window.location.reload();
    throw new Error("Unable to detect chain");
  }
};

export const validateNetwork = async (chainId, web3, setShowModal) => {
  const hexChainId = web3.utils.toHex(chainId);
  console.log("Current Chain ID:", hexChainId, config.chainId);
  if (hexChainId.toLowerCase() != (config.chainId).toLowerCase()) {
    toast.error("Please Select Anannta Chain!");
    setShowModal(false);
    return false;
  }
  return true;
};

export const getWalletAddress = async () => {
  const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
  return accounts[0];
};

export const validateForm = (isChecked, nftBoxValue, userData, handleWalleteVerificationModal, stop_purchase) => {
  if (stop_purchase) {
    toast.error("We hope you enjoyed the StepMint journey with Mr Mint Token. Stay tuned, as we'll be back with the ANANT coin.");
    return false;
  }
  if (!isChecked) {
    toast.dismiss();
    toast.error("Please first agree to the terms");
    return false;
  }
  if (!nftBoxValue) {
    toast.error("Please enter NFT Box value");
    return false;
  }
  if (!userData.bnb_address) {
    handleWalleteVerificationModal();
    return false;
  }
  return true;
};

export const realPayableAmountFromContract = async (web3, nftBoxValue) => {
  const contractWallet = new web3.eth.Contract(
    config.nftBoxContractAbi,
    config.nftBoxPurchaseContractAddress
  );
  const usdtValue = Web3.utils.toWei(nftBoxValue.toString(), "ether");
  const mntTokens = await contractWallet.methods.getUsdtInAnant(usdtValue).call();
  const updateAmountToken = parseFloat((mntTokens / 1e18));
  return { contractWallet, updateAmountToken };
};

export const prepareTransactionData = async (web3, from_address, nftBoxValue) => {
  const contractWallet = new web3.eth.Contract(
    config.nftBoxContractAbi,
    config.nftBoxPurchaseContractAddress
  );
  const usdtValue = Web3.utils.toWei(nftBoxValue.toString(), "ether");
  const mntTokens = await contractWallet.methods.getUsdtInAnant(usdtValue).call();
  const updateAmountToken = parseFloat((mntTokens / 1e18));

  let balance = await web3.eth.getBalance(from_address);
  const balanceOf = parseFloat((balance / 1e18).toFixed(6));

  return { contractWallet, updateAmountToken, balanceOf };
};

export const processTransaction = async (
  web3,
  contractWallet,
  from_address,
  updateAmountToken,
  nftBoxValue,
  setbuyTransactionHash,
  setprocess,
  setMintingTimer,
  setShowModal,
  setShowNftSuccessModal,
  creditBalance
) => {
  try {
    // const payableCreditBalance = Web3.utils.toWei(creditBalance.toString(), "ether");
    // const usdtValue = Web3.utils.toWei(nftBoxValue.toString(), "ether");

    // const valueEth = await contractWallet.methods.getUsdtInAnant(usdtValue).call();
    // const encoded_tx = contractWallet.methods.addInvestment(nftBoxValue / 100, payableCreditBalance).encodeABI();

    // let gasPrice = parseInt(await web3.eth.getGasPrice()) + 1e9;

    // const balance = await web3.eth.getBalance(from_address);
    // const gasFee = (285000 * gasPrice) / 1e18;
    // const currentBalance = parseFloat((balance / 1e18).toFixed(6));
    // let paybalAmount = parseFloat(((valueEth / 1e18) - creditBalance).toFixed(6));

    // if ((gasFee + paybalAmount) > currentBalance) {
    //   toast.error(`Insufficient gas fee. Minimum ${(gasFee + paybalAmount).toFixed(6)} Anant required.`);
    //   return;
    // }

    // let finalPayEthValue = valueEth;
    // if (payableCreditBalance > 0) {
    //   finalPayEthValue = valueEth - payableCreditBalance;
    // }
    // console.log("Value Eth from Contract:", valueEth);
    // console.log("Final Payable Eth Value:", finalPayEthValue + payableCreditBalance);


    /* global BigInt */
    const payableCreditBalance = BigInt(Web3.utils.toWei(creditBalance.toString(), "ether"));
    const usdtValue = BigInt(Web3.utils.toWei(nftBoxValue.toString(), "ether"));

    const valueEth = BigInt(await contractWallet.methods.getUsdtInAnant(usdtValue.toString()).call());

    const bufferWei = BigInt(Web3.utils.toWei("0.0001", "ether"));

    let VirtualAmount = 0;
    // final payable amount
    let payEthWei = valueEth + bufferWei;

    if (payableCreditBalance > BigInt(0)) {
      payEthWei = (valueEth - payableCreditBalance) + bufferWei;
      VirtualAmount = payableCreditBalance - bufferWei;
    }

    // correct: division must not produce float
    const boxValueAdjusted = Number(nftBoxValue) / 100;

    // encode tx (BigInts MUST be strings)

    const encoded_tx = contractWallet.methods
      .addInvestment(boxValueAdjusted, VirtualAmount.toString())
      .encodeABI();

    // gas
    let gasPrice = BigInt(await web3.eth.getGasPrice()) + BigInt(1_000_000_000);
    const gasFeeWei = BigInt(285000) * gasPrice;

    // balance
    const balanceWei = BigInt(await web3.eth.getBalance(from_address));

    // required amount
    const totalRequired = gasFeeWei + payEthWei;

    // check balance
    if (balanceWei < totalRequired) {
      const needEth = Number(totalRequired) / 1e18;
      toast.error(`Insufficient balance. Need at least ${needEth.toFixed(6)} ANANT.`);
      return;
    }

    console.log("Value Eth from Contract:", valueEth.toString());
    console.log("Final Payable Eth Value:", (payEthWei + payableCreditBalance).toString());
    console.log("Final Payable Eth Value is :", payEthWei >= payableCreditBalance);


    const gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice.toString()),
      to: config.nftBoxPurchaseContractAddress,
      value: payEthWei.toString(),
      from: from_address,
      data: encoded_tx,
    });

    const trx = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice.toString()),
      gas: web3.utils.toHex(gasLimit),
      to: config.nftBoxPurchaseContractAddress,
      value: payEthWei.toString(),
      from: from_address,
      data: encoded_tx,
    });
    console.log("Transaction response:", trx);
    if (trx) {
      const trxHash = trx.transactionHash;
      setbuyTransactionHash(trxHash);
      toast.success("Transaction created successfully");

      // 🟢 Mark process as true since tx broadcasted
      setprocess(true);

      // 🔁 Try to confirm transaction receipt (handle "tx not found" + "Failed to check" errors)
      let receipt = null;
      for (let i = 0; i < 5; i++) {
        try {
          receipt = await web3.eth.getTransactionReceipt(trxHash);
          if (receipt) break;
        } catch (innerErr) {
          const msg = innerErr?.message || "";
          if (
            msg.includes("tx not found") ||
            msg.includes("Failed to check for transaction receipt")
          ) {
            console.warn(`Receipt not available yet (attempt ${i + 1}/5). Retrying...`);
          } else {
            console.warn("Unexpected error while checking receipt:", innerErr);
          }
        }
        await new Promise((r) => setTimeout(r, 3000));
      }

      if (!receipt) {
        console.warn(
          "Transaction receipt not found yet, but tx was broadcast successfully. Likely node delay."
        );
      } else if (receipt.status === false) {
        toast.error("Transaction failed on-chain (reverted).");
        setprocess(false);
        return;
      }

      // ✅ Proceed with modal + timer UI
      setTimeout(() => {
        setShowModal(true);
        let timer = 120;
        const interval = setInterval(() => {
          timer -= 1;
          setMintingTimer(timer);
          if (timer <= 0) {
            clearInterval(interval);
            setShowModal(false);
            setShowNftSuccessModal(true);
            setprocess(false);
          }
        }, 1500);
      }, 1000);
    }
  } catch (error) {
    // await updateCreditWalletStatusAction({ type: 'release' });
    console.error("Transaction failed:", error);

    const errMsg =
      error?.data?.message ||
      error?.message ||
      (typeof error === "string" ? error : "");

    if (errMsg.includes("Virtual amount should be below the prescribed limit")) {
      toast.error(`Transaction failed: Credit balance should be below the prescribed limit : ${config.creditUsePercent}%`);
      setprocess(false);
      return;
    }
    // 🧩 Ignore benign MetaMask RPC issues but keep process true
    if (
      errMsg.includes("tx not found") ||
      errMsg.includes("Internal JSON-RPC error") ||
      errMsg.includes("Failed to check for transaction receipt")
    ) {
      console.warn("Ignoring harmless MetaMask RPC error:", errMsg);
      setprocess(true); // keep process active while waiting for confirmation
      return;
    }

    // 🧨 Handle user rejection or genuine error
    if (errMsg.includes("User denied transaction signature")) {
      toast.error("Transaction rejected by user.");
      setprocess(false);

    } else {
      if (errMsg.includes("tx not found") ||
        errMsg.includes("Internal JSON-RPC error") ||
        errMsg.includes("Failed to check for transaction receipt")) {
        setprocess(true); // keep process active while waiting for confirmation
        return;
      } else {
        toast.error(`Transaction failed: ${error.message || error}`);
        setprocess(false);
      }
    }

  }
};


export const handleError = (err, setShowModal, settransactionError) => {
  setShowModal(false);

  if (err.code === 4001) {
    toast.error("User Rejected the transaction");
  } else if (err.code === -32002) {
    toast.error("Request already processing, check MetaMask");
  } else if (err.code === -32603) {
    toast.error("Insufficient Allowance: " + err.message);
  } else if (err.code === -32000) {
    toast.error("Gas Required Exceeds: " + err.message);
  } else if (err.message?.includes("insufficient funds")) {
    toast.error("Transaction reverted: " + err.message);
    settransactionError("Transaction reverted: " + err.message);
  } else if (err.message?.includes("execution reverted:")) {
    const msg = err.message.split("execution reverted:")[1].split("{")[0];
    toast.error("Transaction reverted: " + msg);
    settransactionError("Transaction reverted: " + msg);
  } else {
    toast.error(err.message || "An unknown error occurred");
    settransactionError(err.message);
  }
};
